import "./ContactHeader.css";
import { Navbar } from "../Navbar/Navbar.js";

const ContactHeader = () => {
  return (
    <section className="contact-hero">
    <Navbar />
      <div className="contact-hero-content">

        {/* <span className="contact-tag">Contact Us</span> */}

        <h1>Let’s Create Something Beautiful Together</h1>

        <p>
          Have a project in mind or need expert guidance for your home interiors?
          Reach out to us — we’d love to hear from you.
        </p>

        <a href="/contact#contact" className="projects-btn">
            Contact Us
        </a>

      </div>
    </section>
  );
}

export { ContactHeader };